import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const question: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5.5-2.187v1.875a.3.3 0 0 1-.094.218.3.3 0 0 1-.218.094H3.313a.3.3 0 0 1-.22-.094A.3.3 0 0 1 3-.312v-1.875q0-.125.094-.22a.3.3 0 0 1 .219-.093h1.875q.124 0 .218.094a.3.3 0 0 1 .094.219m2.469-4.688q-.001.422-.125.797a2.4 2.4 0 0 1-.266.594q-.157.22-.437.453-.27.236-.438.344a9 9 0 0 1-.484.28c-.211.118-.387.282-.531.5q-.222.332-.22.532a.4.4 0 0 1-.093.25q-.095.127-.219.125H3.281q-.11 0-.203-.14A.6.6 0 0 1 3-3.438v-.36q-.002-.639.5-1.219a3.3 3.3 0 0 1 1.125-.843q.469-.217.656-.438a.88.88 0 0 0 .203-.594q0-.327-.375-.578a1.44 1.44 0 0 0-.828-.25q-.515 0-.843.219-.282.205-.844.906a.28.28 0 0 1-.235.125.4.4 0 0 1-.203-.062L.875-7.516a.36.36 0 0 1-.125-.187.3.3 0 0 1 .047-.219Q2.044-9.998 4.422-10c.414 0 .832.086 1.25.25q.638.235 1.14.64.514.41.829 1 .328.58.328 1.235m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.746 10)"
    />
  ),
  svgProps: {
    height: "10",
    width: "7.223",
  }
};

export const questionCircle: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7-1.25v-1.5a.22.22 0 0 0-.078-.172A.22.22 0 0 0 6.75-3h-1.5a.26.26 0 0 0-.187.078A.23.23 0 0 0 5-2.75v1.5q0 .111.063.188Q5.138-1 5.25-1h1.5q.106 0 .172-.062A.26.26 0 0 0 7-1.25M9-6.5q-.002-.685-.437-1.266a2.8 2.8 0 0 0-1.079-.906A2.9 2.9 0 0 0 6.156-9c-1.261 0-2.226.555-2.89 1.656q-.127.188.062.328l1.031.782q.048.046.141.047a.26.26 0 0 0 .203-.094q.403-.53.672-.719.262-.187.672-.187.375.002.656.203c.195.136.297.293.297.468 0 .2-.055.36-.156.485q-.157.174-.531.344a2.9 2.9 0 0 0-.907.671q-.408.457-.406.985v.281q0 .111.063.188.075.063.187.062h1.5q.106 0 .172-.062A.26.26 0 0 0 7-3.75q-.002-.155.172-.39.17-.234.422-.391c.164-.094.289-.164.375-.219.094-.05.21-.14.36-.266q.231-.198.359-.375A2 2 0 0 0 9-6.5m2.188-1.516Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.002 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};
